// @ts-nocheck
// Import GSAP
// declare var gsap: any;
const General = (()=>{

    const disabledLogoHeader = ()=>{
        const stars = document.querySelector('.stars__container');
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');
        const headerLink = document.querySelector('header a');

        //Disabled stars
        stars && stars.classList.add('disabled');
        //Validate animation and execute in a scroll
        document.querySelector('#enable-scroll-animation') && window.addEventListener('scroll', ()=>{
            const screenHeigth = window.screen.height;
            const positionScroll = window.scrollY;
            //Calc heigth and scroll position
            if(positionScroll > screenHeigth){
                stars && stars.classList.remove('disabled');
                header && header.classList.add('blue');
                footer && footer.classList.add('dark');
            }else{
                stars && stars.classList.add('disabled');
                header && header.classList.remove('blue');
            }
        });
    }

    return {
        ChildsGeneral : function(){
            try{ anchorWorks() }catch(err){  }
            try{ executeAnchor() }catch(err){  }
            try{ disabledLogoHeader() }catch(err){  }
        }
    }

})();

const getChildsGeneral = ()=>{
    General.ChildsGeneral();
}

export { getChildsGeneral }